import axios from 'axios';
import { getExpressAPIHost } from '../../../../utils';

const getDeliveryDocumentVersions = async (id) => {
    const response = await axios.get(`${getExpressAPIHost()}/delivery-documents/raw-milk/${id}/versions`);
    return response.data;
};

export default getDeliveryDocumentVersions;
